export default {
  props: {
    validation: {
      type: [Array, Object]
    }
  },
  computed: {
    formValidation () {
      return {
        value: this.validation
      }
    }
  },
  methods: {
    validate () {
      this.$emit('validateForm')
    }
  }
}
